import { useMemo } from 'react';
import { getTestIds } from "./getTestIds";
export const useTestIds = parentTestId => {
  return useMemo(() => getTestIds(parentTestId), [parentTestId]);
};